import React from "react";
import { Badge, Alert } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";

const Step1ReceiverList = ({ selectedReceivers, onToggleReceiver }) => {
  const mockData = [
    {
      id: "8385",
      name: "SPM MYR",
      contactNo: "--",
      receiverType: "Individual",
      relationship: "Customer",
      bank: "RHB ISLAMIC BANK BERHAD",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "09/03/2026 16:49:07",
      status: "--",
    },
    {
      id: "8384",
      name: "SparkMinds personal",
      contactNo: "--",
      receiverType: "Individual",
      relationship: "Customer",
      bank: "RHB BANK BERHAD",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "09/03/2026 16:47:43",
      status: "--",
    },
    {
      id: "8376",
      name: "SparkMinds",
      contactNo: "--",
      receiverType: "Individual",
      relationship: "Business partner",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "06/03/2026 18:37:48",
      status: "--",
    },
  ];

  const columns = [
    { label: "ID", key: "id" },
    {
      label: "Name",
      key: "name",
      render: (item) => <span className="fw-bold text-black">{item.name}</span>,
    },
    { label: "Contact No", key: "contactNo" },
    { label: "Receiver Type", key: "receiverType" },
    { label: "Relationship", key: "relationship" },
    { label: "Bank", key: "bank" },
    { label: "Correspondence Bank", key: "correspondenceBank" },
    { label: "Delivery Method", key: "deliveryMethod" },
    { label: "Created Date", key: "createdDate" },
    { label: "Status", key: "status" },
  ];

  return (
    <div className="mt-2">
      <div className="d-flex align-items-center mb-4 gap-2">
        <div style={{ width: "250px" }}>
          <CommonInput placeholder="Enter receiver name" />
        </div>
        <CommonButton variant="outline">
          <i className="flaticon-381-repeat-1"></i>
        </CommonButton>
        <CommonButton>
          <i className="fa fa-search text-white"></i>
        </CommonButton>
      </div>

      <div
        className="card shadow-none rounded-4 mb-4"
        style={{ backgroundColor: "#F9FAFB" }}
      >
        <div className="card-body p-0 overflow-hidden">
          <DataTable
            columns={columns}
            data={mockData}
            showPagination={false}
            rowClassName={(item) =>
              selectedReceivers.some((r) => r.id === item.id)
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => onToggleReceiver(item)}
            minWidth="100%"
          />
        </div>
      </div>

      {/* {selectedReceivers.length > 0 && (
        <div className="mt-auto">
          <Alert
            variant="warning"
            className="py-2 px-3 border-0 mb-3 d-flex align-items-center"
            style={{
              backgroundColor: "#FFF4E6",
              color: "#B45309",
              fontSize: "12px",
              borderRadius: "10px",
            }}
          >
            <i className="fa fa-info-circle me-3 fs-14"></i>
            Bank transfer payments made after 6 PM Friday, on weekends, or on
            public holidays will be processed on the next business day.
          </Alert>
          <div className="mb-4">
            <div className="text-muted fs-11 fw-bold mb-2">
              Selected beneficiaries
            </div>
            <div className="d-flex flex-wrap gap-2">
              {selectedReceivers.map((receiver) => (
                <Badge
                  key={receiver.id}
                  bg="light"
                  className="text-black border px-3 py-2 d-flex align-items-center"
                  style={{
                    borderRadius: "20px",
                    fontSize: "12px",
                    backgroundColor: "#EFF6FF",
                    borderColor: "#3B82F6",
                    color: "#1E40AF",
                  }}
                >
                  {receiver.name}
                  <i
                    className="fa fa-times ms-2 cursor-pointer text-muted"
                    onClick={() => onToggleReceiver(receiver)}
                  ></i>
                </Badge>
              ))}
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Step1ReceiverList;
